import { render } from "./MySection.vue?vue&type=template&id=bc860c72"
import script from "./MySection.vue?vue&type=script&lang=js"
export * from "./MySection.vue?vue&type=script&lang=js"

import "./MySection.vue?vue&type=style&index=0&id=bc860c72&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__